// views/Settings/VendorAlertsSettingsPage.js
// Order alerts for the business (channels and contacts) and this person's own
// alert sound, on one page in the vendor Settings group. The two components
// are the ones the profile screens embed; nothing new. There is no desktop
// notification control here: AlertSoundPrefs sets tone and volume only.
import React from "react";
import SettingsPanel from "../../components/SettingsPanel";
import VendorAlertSettings from "../../components/VendorAlertSettings";
import AlertSoundPrefs from "../../components/AlertSoundPrefs";

const VendorAlertsSettingsPage = () => (
  <SettingsPanel icon="fa-bell" title="Alerts" subtitle="How your business hears about orders by email, SMS and WhatsApp, and the sound your own dashboard plays" maxWidth={960}>
    <SettingsPanel.Section title="Order alerts for the business" icon="fa-paper-plane">
      <VendorAlertSettings />
    </SettingsPanel.Section>
    <SettingsPanel.Section title="Your own alert sound" icon="fa-volume-high">
      <AlertSoundPrefs />
    </SettingsPanel.Section>
  </SettingsPanel>
);

export default VendorAlertsSettingsPage;
